const passthroughFunc = param => param

export default passthroughFunc
